import React from 'react';

export interface StepBarProps {
  current: number;
  onSelect: (step: number) => void;
  unlocked: boolean[];
  labels: string[];
}

const StepBar: React.FC<StepBarProps> = ({ current, onSelect, unlocked, labels }) => (
  <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', flexShrink: 0 }}>
    {labels.map((label, i) => {
      const step = i + 1;
      const isActive = current === step;
      const canClick = unlocked[i];
      return (
        <React.Fragment key={step}>
          <button
            onClick={() => canClick && onSelect(step)}
            disabled={!canClick}
            style={{
              fontSize: 11, padding: '7px 16px', fontWeight: isActive ? 700 : 400,
              color: isActive ? '#2563eb' : canClick ? '#475569' : '#cbd5e1',
              background: isActive ? '#eff6ff' : 'transparent',
              border: 'none', borderBottom: isActive ? '2px solid #2563eb' : '2px solid transparent',
              cursor: canClick ? 'pointer' : 'default', whiteSpace: 'nowrap',
            }}
          >
            {step}. {label}
          </button>
          {i < labels.length - 1 && (
            <span style={{ color: '#cbd5e1', fontSize: 12 }}>›</span>
          )}
        </React.Fragment>
      );
    })}
  </div>
);

export default StepBar;
